var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3978 8.375L13.095 16.25M8.90505 16.25L8.60216 8.375M17.3242 5.56675C17.6234 5.61194 17.9216 5.66029 18.2187 5.71175M17.3242 5.56675L16.3898 17.7135C16.3109 18.7392 15.4556 19.5312 14.4269 19.5312H7.57312C6.54438 19.5312 5.68907 18.7392 5.61017 17.7135L4.67581 5.56675M17.3242 5.56675C16.3211 5.41526 15.3063 5.29925 14.2812 5.22003M3.78125 5.71175C4.07838 5.66029 4.37657 5.61194 4.67581 5.56675M4.67581 5.56675C5.67893 5.41526 6.69368 5.29925 7.71875 5.22003M14.2812 5.22003V4.41841C14.2812 3.38647 13.4844 2.52495 12.453 2.49196C11.9706 2.47653 11.4862 2.46875 11 2.46875C10.5138 2.46875 10.0294 2.47653 9.54699 2.49196C8.51557 2.52495 7.71875 3.38647 7.71875 4.41841V5.22003M14.2812 5.22003C13.1985 5.13636 12.1042 5.09375 11 5.09375C9.89578 5.09375 8.80151 5.13636 7.71875 5.22003",
    stroke: "#F42829",
    strokeWidth: 1.275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.602700bc5fa0610bed76755735688bec.svg";
export { ForwardRef as ReactComponent };